import { useAppDispatch } from "app/hooks";
import { setPendingForm } from "features/subscription-process/slices/subscriptionProcessSlice";
import { useCallback } from "react";
import { SearchPersonResult } from "components/domain/SearchBar/types";

export const useSearchBarSelect = () => {
  const dispatch = useAppDispatch();

  const handleSelectNaturalPerson = useCallback(async (person: SearchPersonResult | null) => {
    if (!person) return;
    dispatch(setPendingForm({ entity: person.data }));
  }, [dispatch]);

  return {
    handleSelectNaturalPerson,
  }
}
